/**
 * ZITELOU BACK OFFICE - Main App
 */

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/Common';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import UserDetails from './pages/UserDetails';
import Subscriptions from './pages/Subscriptions';
import SubscriptionDetails from './pages/SubscriptionDetails';
import Statistics from './pages/Statistics';
import Referrals from './pages/Referrals';
import Config from './pages/Config';
import Profile from './pages/Profile';
import NotFound from './pages/NotFound';
import UserEdit from './pages/UserEdit';
// Layout
import MainLayout from './components/Layout/MainLayout';

// API
import api from './services/api';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider
        tokenKey="admin_token"
        userKey="admin_user"
        onLoginSuccess={(user) => {
          console.log('Admin logged in:', user);
        }}
        onLogoutSuccess={() => {
          console.log('Admin logged out');
        }}
      >
        <Routes>
          {/* Public Routes */}
          <Route
            path="/login"
            element={
              <Login
                logo="/logo-mark.svg"
                title="Back Office"
                subtitle="Espace d'administration"
                onLogin={api.login}
                redirectPath="/dashboard"
                showForgotPassword
              />
            }
          />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />

            {/* Users Routes */}
            <Route path="users" element={<Users />} />
            <Route path="users/:id" element={<UserDetails />} />
              <Route path="/users/:id/edit" element={<UserEdit />} />

            {/* Subscriptions Routes */}
            <Route path="subscriptions" element={<Subscriptions />} />
            <Route path="subscriptions/:id" element={<SubscriptionDetails />} />

            {/* Parrainage */}
            <Route
              path="referrals"
              element={
                <ProtectedRoute requiredRole={['super_admin', 'admin']}>
                  <Referrals />
                </ProtectedRoute>
              }
            />

            {/* Statistics Route */}
            <Route path="statistics" element={<Statistics />} />

            {/* Profile Route */}
            <Route path="profile" element={<Profile />} />

            {/* Config Route */}
            <Route
              path="config"
              element={
                <ProtectedRoute requiredRole={['super_admin', 'admin']}>
                  <Config />
                </ProtectedRoute>
              }
            />
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>

        {/* Toast Notifications */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
